import { useLocation, useSearchParams } from "react-router";
import { parse, rebuild } from "../tools/search-params/open-article";
import { useCallback, useMemo } from "react";
import { AnyPeriod, castPeriod, isValidPeriod } from "@ct-react/core";

export const usePeriodParams = (): [ AnyPeriod | undefined, (period?: AnyPeriod) => void ] => {

  const { state } = useLocation();
  const [ searchParams, setSearchParams ] = useSearchParams();

  const period = useMemo((): AnyPeriod | undefined => parse(searchParams)?.bookingPeriod, [ searchParams ]);

  const setPeriod = useCallback((next?: AnyPeriod) => {
    if (!!period && !!next) {
      const [ prev, casted ] = [ castPeriod(period), castPeriod(next) ];
      if (prev.start == casted.start && prev.end == casted.end) return;
    }
    rebuild(next, searchParams);
    setSearchParams(searchParams, {
      replace: true,
      ...(!!state) && { state }
    });
  }, [ period, searchParams, state ]);

  return [ period, setPeriod ];

}
